import { Box } from '@mui/material';
import { Typography, Button } from '@/components/atoms';
import { EmptyStateProps } from './EmptyState.props';
import {
  containerStyles,
  containerWithBorderStyles,
  textContainerStyles,
  titleStyles,
  descriptionStyles,
  buttonStyles,
} from './EmptyState.theme';

/**
 * EmptyState - Displays an empty state message for no data found scenarios.
 *
 *
 * Usage:
 * ```tsx
 * <EmptyState
 *   title="You don't have any documents added yet for this loan."
 *   description="Add your first document to get started."
 *   buttonText="Add Documents"
 *   onAction={handleAddDocuments}
 *   icon={<DocumentIcon />}
 *   showBorder={true}
 * />
 * ```
 */
export const EmptyState = ({
  title,
  description,
  buttonText,
  onAction,
  icon,
  hideButton = false,
  buttonStartIcon,
  showBorder = false,
  sx,
}: EmptyStateProps) => {
  return (
    <Box
      sx={[
        containerStyles,
        showBorder && containerWithBorderStyles,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {icon}

      <Box sx={textContainerStyles}>
        <Typography sx={titleStyles}>{title}</Typography>
        {description && (
          <Typography sx={descriptionStyles}>{description}</Typography>
        )}
      </Box>

      {!hideButton && buttonText && onAction && (
        <Button
          variant="filled"
          color="primary"
          startIcon={buttonStartIcon}
          onClick={onAction}
          sx={buttonStyles}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
